export const mapData = [{
    accordionDetails: {
        id: "restaurants",
        title: "Restaurants",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut"
    },
    mapDetails: {
        centerCoordinates: [40.670988, -74.100399],
        zoom: 14,
        locations: [
            {
                name: "Houlihan's",
                coordinates: [40.668299, -74.104428],
                highlight: true,
            }, {
                name: "Wendy's",
                coordinates: [40.668504, -74.106489],
                highlight: true,
            },
            {
                name: "Bubbakoo's Burritos",
                coordinates: [40.667666, -74.105202],
                highlight: true,
            },
            {
                name: "Starbucks",
                coordinates: [40.671992, -74.104402],
                highlight: true,
            }, {
                name: "Dunkin Donutes",
                coordinates: [40.668641, -74.106984],
                highlight: true,
            }, {
                name: "Panda Express",
                coordinates: [40.662962, -74.106648],
                highlight: false,
            }, {
                name: "Five Guys",
                coordinates: [40.662884, -74.106266],
                highlight: false,
            }, {
                name: "Wonder Bagels",
                coordinates: [40.662426, -74.105979],
                highlight: false,
            },
            {
                name: "Qdoba Mexican Eats",
                coordinates: [40.660931, -74.108453],
                highlight: false,
            },
            {
                name: "Jersey Mike's Subs",
                coordinates: [40.660541, -74.107895],
                highlight: false
            }]
    }
},
{
    accordionDetails: {
        id: "parks",
        title: "Parks",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut"
    },
    mapDetails: {
        centerCoordinates: [40.670988, -74.100399],
        zoom: 12,
        locations: [{
            name: "James J. Donovan Park",
            coordinates: [40.670540, -74.096501],
            highlight: true,
        },
        {
            name: "Bayonne Park",
            coordinates: [40.679475, -74.101452],
            highlight: true,
        }, {
            name: "Hudson County Park",
            coordinates: [40.679987, -74.116925],
            highlight: true,
        },
        {
            name: "Stephen R. Greg Park",
            coordinates: [40.682526, -74.114650],
            highlight: true,
        },
        {
            name: "Liberty State Park",
            coordinates: [40.705805, -74.055368],
            highlight: false
        }]
    }
}, 
{
    accordionDetails: {
        id: "shopping",
        title: "Shopping",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut"
    },
    mapDetails: {
        centerCoordinates: [40.670988, -74.100399],
        zoom: 16,
        locations: [{
            name: "Costco",
            coordinates: [40.672945, -74.103929],
            highlight: true,
        },
        {
            name: "Lidl",
            coordinates: [40.670828, -74.106556],
            highlight: true,
        }, {
            name: "CVS",
            coordinates: [40.671762, -74.106107],
            highlight: true,
        },
        {
            name: "Stop and Shop",
            coordinates: [40.666865, -74.104591],
            highlight: true,
        },
        {
            name: "Walmart",
            coordinates: [40.660329, -74.106909],
            highlight: true,
        }]
    }
},
{
    accordionDetails: {
        id: "fitness",
        title: "Fitness",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut"
    },
    mapDetails: {
        centerCoordinates: [40.670988, -74.100399],
        zoom: 14,
        locations: [{
            name: "LA Fitness",
            coordinates: [40.670510, -74.104505],
            highlight: true,
        },
        {
            name: "CKO Kickboxing Bayonne",
            coordinates: [40.672359, -74.110728],
            highlight: true,
        }, {
            name: "Stanlaw Fitness",
            coordinates: [40.670194, -74.112604],
            highlight: true,
        },
        {
            name: "Orange Theory Fitness",
            coordinates: [40.659695, -74.110547],
            highlight: true,
        }]
    }
}, {
    accordionDetails: {
        id: "transit",
        title: "Transit",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut"
    },
    mapDetails: {
        centerCoordinates: [40.670988, -74.100399],
        zoom: 14,
        locations: [{
            name: "AQUA Shuttle to Path",
            coordinates: [40.671888, -74.100544],
            highlight: true
        },

        {
            name: "34 St/Hoboken Light Rail Station",
            coordinates: [40.671105, -74.107041],
            highlight: true,
        },
        {
            name: "Upcoming Ferry",
            coordinates: [40.667004, -74.086441],
            highlight: true,
        }, {
            name: "Cape Liberty Cruise Port",
            coordinates: [40.664601, -74.071723],
            highlight: true,
        },
        {
            name: "45th Street Light Rail Station",
            coordinates: [40.678921, -74.102109],
            highlight: true,
        }]
    }
},
{
    accordionDetails: {
        id: "schools",
        title: "Schools",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut"
    },
    mapDetails: {
        centerCoordinates: [40.670988, -74.100399],
        zoom: 13,
        locations: [{
            name: "Bayonne High School",
            coordinates: [40.671461, -74.121588],
            highlight: true
        },
        {
            name: "Horace Mann Elementary School",
            coordinates: [40.676018, -74.108885],
            highlight: true,
        },
        {
            name: "Philip G. Vroom Elementary School",
            coordinates: [40.666500, -74.116598],
            highlight: true,
        }, {
            name: "Lincoln Community School",
            coordinates: [40.666874, -74.110199],
            highlight: true,
        },
        {
            name: "Washington Elementary School",
            coordinates: [40.683520, -74.108311],
            highlight: true,
        },
        {
            name: "Beacon Christian Academy",
            coordinates: [40.660438, -74.115847],
            highlight: false,
        },
        {
            name: "Nicholas Oresko School PS 14",
            coordinates: [40.663758, -74.115384],
            highlight: false,
        },
        {
            name: "William Shemin Midtown Community School",
            coordinates: [40.667435, -74.123056],
            highlight: false,
        },
    ]
    }
},
{
    accordionDetails: {
        id: "medicalServices",
        title: "Medical Services",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut"
    },
    mapDetails: {
        centerCoordinates: [40.670988, -74.100399],
        zoom: 14,
        locations: [{
            name: "CityMD Bayonne Urgent Care",
            coordinates: [40.660522, -74.108488],
            highlight: true
        },
        {
            name: "Bayonne Medical Center: Emergency Room",
            coordinates: [40.667633, -74.111955],
            highlight: true
        },
        {
            name: "Barnabas Health Medical Group United Medical",
            coordinates: [40.681217, -74.103090],
            highlight: true
        },
        {
            name: "RWJ Barnabas Health at Bayonne",
            coordinates: [40.664251, -74.118115],
            highlight: true,
        }]
    }
}]